import { getGiveawayById as getGiveawayLandingById } from '../redux/giveaway-landing/giveaway-landing.actions';
import { scrollToTop } from '../middleware/window-manipulations.middleware';
export const onGiveawayLandingPreviewEnter = (store, dispatch) => state => {
  const {
    inventoryId,
    giveawayId
  } = state.params;
  dispatch(getGiveawayLandingById({
    inventoryId,
    giveawayId
  }));
};
export const onGoodieLandingEnter = (store, dispatch) => () => {
  dispatch(scrollToTop());
};